import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../../interfaces/response";

export interface IAggregatorRole {
  name: string;
  value: string;
}

const getAggregatorRoles = async (): Promise<IResponse<IAggregatorRole[]>> => {
  const data = await getDataWithDotNet(ajaxEndpoints.AGGREGATOR_ROLES);
  return data;
};

export default function useGetAggregatorRoles() {
  return useQuery(["getAggregatorRoles"], getAggregatorRoles, {
    refetchOnWindowFocus: false,
  });
}
